/* eslint-disable no-plusplus */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState } from 'react'

import { Typography } from '@material-ui/core'

import useStyles from './RejectAndDeactivationManagement.styles'

export default function RejectAndDeactivationManagement({
  title,
  titleButton,
  handleCancelClick,
  handleRejectClick,
}) {
  const classes = useStyles()

  const [reason, setReason] = useState('')

  useEffect(() => {
    return () => {
      setReason('')
    }
  }, [])
  return (
    <>
      <Typography className={classes.dialogTitle}>{title}</Typography>
      <label className={classes.label} htmlFor="motivo">
        Motivo
      </label>
      <input
        id="motivo"
        className={classes.input}
        value={reason}
        onChange={(e) => {
          if (e.target.value.length < 255) setReason(e.target.value)
        }}
      />

      <div className={classes.actions}>
        <button type="button" className={classes.cancelButton} onClick={handleCancelClick}>
          Cancelar
        </button>
        <button
          type="button"
          className={classes.rejectButton}
          onClick={() => handleRejectClick(reason)}
        >
          {titleButton}
        </button>
      </div>
    </>
  )
}
